export default __webpack_public_path__ + "static/media/countdown.197e6933.webp";